import get from 'lodash.get';
import { defineMessages } from 'react-intl';

import { emptyArray } from 'ui-components/default-props/empty';
import { CodeToFormattedMessageProps } from './code-to-formatted-message-props';

const messages = defineMessages({
  error: {
    description: 'Generic word: "Error"',
    defaultMessage: 'Error',
    id: 'LvbTRH',
  },
  unknown: {
    description: 'Generic unknown error message',
    defaultMessage: 'Something wrong happened. Please try again.',
    id: 'Ang2pz',
  },
});

export const getUserFriendlyMessagesForErrorResponse = (
  responseData = {
    Errors: [],
    errors: [],
  },
) => {
  const rateError = get(responseData, 'rateError');
  const errors = responseData?.Errors ?? responseData?.errors ?? emptyArray;
  const isErrorsAnArray = Array.isArray(errors);
  if (!rateError && !isErrorsAnArray) {
    // oxlint-disable-next-line no-console
    console.error(
      `Errors found but not as an iterable, errors data is: ${JSON.stringify(errors, undefined, 2)}, responseData is ${JSON.stringify(responseData)}, defaulting to empty array`,
    );
  }
  const errorsChecked = isErrorsAnArray ? errors : emptyArray;
  const errorMessages = errorsChecked.map((err) => err.Message ?? err.errorMessage);
  const simpleErrors = rateError ? [rateError] : errorMessages;
  const descriptiveErrors = errorsChecked.map((err) => {
    const message = err.Message ?? err.errorMessage;
    const { id, defaultMessage, values } = CodeToFormattedMessageProps(err.Code, err.ErrorContext, message);

    return {
      messageDescriptor: {
        id,
        defaultMessage,
      },
      values,
      apiError: err,
    };
  });

  return {
    errors: descriptiveErrors,
    stringErrors: simpleErrors,
  };
};

export const getWordErrorDescriptor = () => messages.error;
export const getUnknownErrorDescriptor = () => messages.unknown;
